module.exports = __webpack_public_path__ + "static/img/HUANG_HSIN-CHUAN.jpg";